import CertificateList from "src/pages/Certificate/CertificateList";

export const certificateRoutes = [
  { path: '/certificate', component: CertificateList },
];
